import { RadioStationName } from "../../config/audio/types";

declare global {
	interface Window {
		gtag: (...args: any[]) => void;
		startSceneLoad: number;
		startSceneView: number;
	}
}

export const eventStartGame = () => {
	if (!window.gtag) return;
	window.gtag("event", "game_start", {
		game_title: "Cabin",
		player_count: 1,
	});
};

export const eventSceneVisible = (start: number, sceneName: string) => {
	if (!window.gtag) return;
	const end = Date.now();
	const elapsed = end - start;

	window.gtag("event", "scene_visible", {
		scene_name: sceneName,
		load_ms: elapsed,
	});
};

export const eventSceneExit = (start: number) => {
	if (!window.gtag) return;
	const duration = Date.now() - start;
	if (isNaN(duration)) return;

	window.gtag("event", "scene_exit", {
		duration_ms: duration,
	});
};

export const eventInteractiveClick = (
	interactiveId: string,
	verbs: string,
	isProtected: boolean,
) => {
	if (!window.gtag) return;
	window.gtag("event", "interactive_click", {
		interactive_id: interactiveId,
		verbs,
		is_protected: isProtected,
	});
};

export const eventInteractiveNavigateNull = (interactiveId: string, key: string) => {
	if (!window.gtag) return;
	window.gtag("event", "interactive_navigate_null", {
		interactive_id: interactiveId,
		key,
	});
};

export const eventUserProfileClicked = (isAuthenticated: boolean) => {
	if (!window.gtag) return;
	window.gtag("event", "user_profile_clicked", {
		is_logged_in: isAuthenticated,
	});
};

export const eventRadioStart = (station: RadioStationName, gain: number) => {
	if (!window.gtag) return;
	window.gtag("event", "radio_start", {
		station,
		gain,
	});
};

export const eventRadioStop = (station: RadioStationName, gain: number, duration: number) => {
	if (!window.gtag) return;
	window.gtag("event", "radio_stop", {
		station,
		gain,
		duration_played_ms: duration,
	});
};

export const eventRadioVolumeChanged = (
	from: number,
	to: number,
	station: RadioStationName | null,
) => {
	if (!window.gtag) return;
	window.gtag("event", "radio_volume_changed", {
		from,
		to,
		station,
	});
};

export const eventRadioStationChanged = (
	from_station: RadioStationName,
	to_station: RadioStationName,
) => {
	if (!window.gtag) return;
	window.gtag("event", "radio_station_changed", {
		from_station,
		to_station,
	});
};

type ErrorType = "video" | "audio";
export const eventAppError = (message: string, error_type: ErrorType) => {
	if (!window.gtag) return;
	window.gtag("event", "app_error", { error_type, message });
};

export const gaSetUserId = (userId: string | null) => {
	window.gtag("set", { user_id: userId });
};
